const ORDER_GROUPS_TABLE_READY = "order-groups-table-ready"
const SEARCH_TEXT_STATE = "order-groups-table-search-text-state"
const ROWS_PER_PAGE_STATE = "order-groups-table-rows-per-page-state"
const PAGINATION_STATE = "order-groups-table-pagination-state"

const STATUS_FILTER_STATE = "order-groups-table-status-filter-state"
const DATE_FILTER_STATE = "order-groups-table-date-filter-state"
const LEG_TYPE_FILTER_STATE = "order-groups-table-leg-type-filter-state"
const ORDER_GROUP_ID_FOR_ACTION = "order-groups-table-order-group-id-for-action"

const PUSH_GROUP_VALUE = "order-groups-table-push-group-value"


const initialState = {
    isOrderGroupsTableReady: true,
    order_groups: {},
    pushGroupDetails:null,

    previousStatus: 0,
    previousLegType: 0,
    previousStartDate: "",
    previousEndDate: "",

    orderGroupSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ORDER_GROUPS_TABLE_READY:
            return Object.assign({}, state, { isOrderGroupsTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case STATUS_FILTER_STATE:
            return Object.assign({},state,{previousStatus:action.payload})

        case LEG_TYPE_FILTER_STATE:
            return Object.assign({},state,{previousLegType:action.payload})

        case DATE_FILTER_STATE:
            duplicateState =Object.assign({},state)
            duplicateState.previousStartDate=action.payload.start_date
            duplicateState.previousEndDate=action.payload.end_date
            return Object.assign({},state,duplicateState)

        case ORDER_GROUP_ID_FOR_ACTION:
            return Object.assign({}, state, {orderGroupSelectedId:action.payload})
        
        case PUSH_GROUP_VALUE:
            return Object.assign({}, state, { pushGroupDetails: action.payload })

        default:
        return state
    
    }

}

export function orderGroupTableReady(data){
    return{
        type: ORDER_GROUPS_TABLE_READY,
        payload:data
    }
}


export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function pushGroupUpdate(value){
    return{
        type: PUSH_GROUP_VALUE,
        payload:value
    }
}

export function dateFilterSelected(date){
    return{
        type:DATE_FILTER_STATE,
        payload:date
    }
}

export function statusFilterState(status){
    return{
        type:STATUS_FILTER_STATE,
        payload:status
    }
}

export function legTypeFilterState(leg_type){
    return{
        type:LEG_TYPE_FILTER_STATE,
        payload:leg_type
    }
}

export function orderGroupIdForAction(order_group_id){
    return{
        type:ORDER_GROUP_ID_FOR_ACTION,
        payload:order_group_id
    }
}



// WEBPACK FOOTER //
// ./src/modules/OrderGroups/redux/ordergroups.js